module.exports = __webpack_public_path__ + "media/packs/assets/logo-98e0298c52f0810ee50296061e0359b7.png";